<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <h4>고객 엑셀 업로드 (신규 등록 · 후원인/추천인 배치)</h4>
      <p class="guide">
        엑셀 컬럼(첫 행): <b>센터코드</b>, <b>로그인id</b>, <b>이름</b>, <b>추천인id</b>, <b>후원인id</b><br />
        초기 패스워드는 <b>123456</b> 입니다.
      </p>

      <!-- 상단 버튼 : 양식 다운받기 / 업로드 양식 찾기 -->
      <div class="pick-btns">
        <button class="ghost" @click="downloadTemplate">양식 다운받기</button>
        <button class="ghost blue" @click="pickFile">업로드 양식 찾기</button>
        <span v-if="fileName" class="fname">{{ fileName }}</span>
        <input ref="file" type="file" accept=".xlsx,.xls,.csv" class="hidden" @change="onFile" />
      </div>

      <div v-if="rows.length" class="preview">
        <p>선택된 파일: 총 {{ rows.length }}행</p>
      </div>

      <div v-if="result" class="result">반영 완료: {{ result.applied }}건</div>
      <p v-if="error" class="error">{{ error }}</p>

      <!-- 하단 : 업로드 / 닫기 -->
      <div class="modal-btns">
        <button class="primary" :disabled="!rows.length || saving" @click="submit">
          {{ saving ? '업로드 중...' : '업로드' }}
        </button>
        <button class="ghost" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import api from '../api';
import { getAuth } from '../store/auth';

// 엑셀 헤더(한/영 허용) → 표준키 매핑
function pick(row, keys) {
  for (const k of keys) {
    if (row[k] !== undefined && row[k] !== null && String(row[k]).trim() !== '') return String(row[k]).trim();
  }
  return '';
}

export default {
  name: 'ExcelImportDialog',
  data() {
    return { rows: [], fileName: '', saving: false, error: '', result: null };
  },
  methods: {
    downloadTemplate() {
      // 스펙104: 템플릿은 빈 내용이며, 1 row 는 업로드 엑셀 컬럼과 동일해야 한다.
      //   (헤더 행 1줄만 존재하고, 그 아래 빈 데이터 행은 두지 않는다)
      const ws = XLSX.utils.aoa_to_sheet(
        [['센터코드', '로그인id', '이름', '추천인id', '후원인id']]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '고객업로드양식');
      XLSX.writeFile(wb, '고객업로드_양식.xlsx');
    },
    pickFile() { this.$refs.file.click(); },
    onFile(e) {
      this.error = ''; this.result = null;
      const file = e.target.files[0];
      if (!file) return;
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = evt => {
        try {
          const wb = XLSX.read(evt.target.result, { type: 'array' });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(ws, { defval: '' });
          this.rows = json.map(r => ({
            centerId: pick(r, ['센터코드', '센터 ID', '센터ID', '센터 id', 'centerId', 'center_id', 'centerNo']),
            loginId: pick(r, ['로그인id', '로그인 ID', '로그인ID', '로그인Id', 'loginId', 'login_id']),
            name: pick(r, ['이름', 'name', 'Name']),
            sponsor: pick(r, ['후원인id', '후원인 ID', '후원인ID', '후원인', 'sponsor', 'sponsorId', 'parent']),
            referrer: pick(r, ['추천인id', '추천인 ID', '추천인ID', '추천인', 'referrer', 'referrerId', 'ref'])
          })).filter(r => r.loginId);
        } catch (err) {
          this.error = '엑셀 파싱 실패: ' + err.message;
        }
      };
      reader.readAsArrayBuffer(file);
    },
    async submit() {
      this.error = ''; this.result = null; this.saving = true;
      try {
        const res = await api.importCustomers102(this.rows, getAuth().loginId || 'SYSTEM');
        this.result = res.data;
        this.$emit('imported');
        this.$emit('close');   // 스펙40: 업로드 실행(성공) 후 팝업 닫기
      } catch (e) {
        this.error = e.message;   // 불일치 시 백엔드가 rollback + 메시지 반환
      } finally {
        this.saving = false;
      }
    },
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 60; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 620px; max-width: 94vw; }
.modal h4 { margin: 0 0 10px; }
.guide { font-size: 12.5px; color: #555; background: #f6f8ff; padding: 10px; border-radius: 6px; line-height: 1.6; }
.pick-btns { display: flex; align-items: center; gap: 8px; margin: 14px 0 4px; }
.pick-btns button { padding: 8px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; background: #f5f5f5; }
.pick-btns .blue { background: #eef1f7; color: #2f6fed; border-color: #cfdcff; }
.pick-btns .fname { font-size: 12px; color: #2f6fed; }
.hidden { display: none; }
.preview { margin-top: 14px; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; min-width: 420px; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 6px 8px; font-size: 12px; white-space: nowrap; }
.grid th { background: #f0f3fa; }
.result { margin-top: 12px; font-size: 13px; color: #1a7f37; }
.error { color: #d93636; font-size: 13px; margin-top: 10px; }
.modal-btns { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.modal-btns button { padding: 8px 16px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.modal-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.modal-btns .primary:disabled { background: #9db8ef; }
.modal-btns .ghost { background: #f5f5f5; }
</style>
